import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {Formik} from 'formik';
import {useCustomersEntityUIContext} from '../CustomersEntityUIContext';
import PopupAddCustomer from '../PopupAddCustomer/PopupAddCustomer';
import {InputCheckbox} from '../../../_common/components/FieldCheckbox';
import FilterText from '../../../_common/components/FilterText';
import FilterSelect from '../../../_common/components/FilterSelect';
import {customerStatus, customerTypes} from '../../../_common/constants/options';
import {applyFilter} from '../../../../../utils/prepareApplyFilter';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import ButtonAction from '../../../_common/components/ButtonAction';
import {getCustomersListForExcel} from '../../actions/CustomersEntityTableActions';
import {generateExcelFile} from '../../../_common/utils/excel';
import {columnNamesCustomers} from '../../../_common/constants/excelColumnNames';
import styles from '../../../_common/styles/filtersBar.module.scss';

export function CustomersEntityFilters() {
  const customersEntityUIContext = useCustomersEntityUIContext();
  const customersEntityUIProps = useMemo(() => {
    return {
      queryParams: customersEntityUIContext.queryParams,
      setQueryParams: customersEntityUIContext.setQueryParams,
    };
  }, [customersEntityUIContext]);
  const [loading, setLoading] = useState(false);

  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const prefix = 'customers-entity-filter';

  const qs = new URLSearchParams(window.location.search);
  let customerName = qs.get('customerName') || '';
  let customerType = qs.get('customerType') || '';
  let status = qs.get('status') || '';
  let deleted = qs.get('deleted') || '';

  const handleExport = () => {
    setLoading(true);
    dispatch(getCustomersListForExcel(customersEntityUIProps.queryParams))
      .then(prepareDataForExcel)
      .then((data) => {
        generateExcelFile(
          data,
          'Customers.xlsx',
          'לקוחות'
        );
      })
      .catch((error) => {
        console.error(`Error: + ${error}`);
      }).finally(() => setLoading(false));
  };
  const prepareDataForExcel = data => {
    return data.map((item, index) => {
      const {
        customerID,
        firstName,
        lastName,
        phone,
        email,
        customerTypeName,
        idNumber,
        customerStatus
      } = item;

      return {
        [columnNamesCustomers[0]]: index + 1,
        [columnNamesCustomers[1]]: customerID || '',
        [columnNamesCustomers[2]]: [firstName, lastName].filter(Boolean).join(' '),
        [columnNamesCustomers[3]]: phone || '',
        [columnNamesCustomers[4]]: email || '',
        [columnNamesCustomers[5]]: customerTypeName || '',
        [columnNamesCustomers[6]]: idNumber || '',
        [columnNamesCustomers[8]]: customerStatus || '',
      };
    });
  };

  return (
    <Formik
      initialValues={{
        customerName,
        customerType,
        status,
        deleted,
      }}
      onSubmit={(values) => applyFilter(values, customersEntityUIProps)}
      enableReinitialize={true}
    >
      {({values, handleBlur, handleSubmit, setFieldValue}) => (
        <form onSubmit={handleSubmit} className={styles.container}>
          <div className={styles.filtersContainer}>
            <FilterText
              fieldName={'customerName'}
              value={values.customerName}
              placeholder={formatMessage({id: `${prefix}-customer-name`, defaultMessage: 'Name'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterSelect
              fieldName={'customerType'}
              valueName={values.customerType}
              options={customerTypes}
              placeholder={formatMessage({id: `${prefix}-customer-type`, defaultMessage: 'Type'})}
              containerClassnames={styles.filter}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterSelect
              fieldName={'status'}
              valueName={values.status}
              options={customerStatus}
              placeholder={formatMessage({id: `${prefix}-customer-type`, defaultMessage: 'Type'})}
              containerClassnames={styles.filter}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <InputCheckbox
              fieldId={'deleted'}
              value={values.deleted}
              label={formatMessage({id: `${prefix}-deleted`, defaultMessage: 'With deleted customers',})}
              onChange={() => {
                setFieldValue('deleted', !values.deleted);
                handleSubmit();
              }}
              customContainerStyles={styles.filter}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <PopupAddCustomer
              buttonVariant={'primary'}
              customLabel={
                <div>
                  <img src={toAbsoluteUrl('/media/common/Plus_white.svg')} alt="create" className={'mr-2'}/>
                  <span>{formatMessage({id: 'customers-entity-add-row-button', defaultMessage: 'Add customer'})}</span>
                </div>
              }
            />
            <ButtonAction
              variant={'success'}
              label={
                <>
                  {loading
                    ? (
                      <div className="spinner-border spinner-border-md m-auto text-light" role="status"/>
                    )
                    : (
                      <>
                        <img
                          src={toAbsoluteUrl('/media/common/Excel_white.svg')}
                          alt="export" className={'mr-2'}
                        />
                        <span>{formatMessage({id: 'button-export-to-excel', defaultMessage: 'Export'})}</span>
                      </>
                    )
                  }
                </>
              }
              onClick={handleExport}
              customClassnames={'w-100px ml-4'}
            />
          </div>
        </form>
      )}
    </Formik>
  );
}

export default CustomersEntityFilters;
